import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../../Component/Model/helpers';

export const deviationSchema = yup.object({
	reason: yup
		.number()
		.nullable()
		.transform((value, originalValue) => {
			return originalValue === '' ? null : value;
		})
		.required('Justifiable Reason is required')
		.typeError('Justifiable Reason is required'),
	comment: yup
		.string()
		.nullable()
		.test('commentLengthTest', `Comment is too long (Max length is 6000 characters)`, (value) => {
			if (!value) {
				return true;
			}
			return DataTableHtmlFormatter(value, '').length <= 6000;
		})
});
